import { render } from "./userFormDist.vue?vue&type=template&id=0f0e111f"
import script from "./userFormDist.vue?vue&type=script&lang=js"
export * from "./userFormDist.vue?vue&type=script&lang=js"

import exportComponent from "/home/accesa/Documents/ACCESA/DANA_PROJECTS/DANA-LITE/dana-lite-registro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__